// @ts-nocheck — legacy guide script ported from static HTML
import { trackGuideFinishView, trackStepComplete } from './analytics';

var LS_PREFIX = 'valvur-welcome:';

function lsGet(key) {
  try {
    return localStorage.getItem(LS_PREFIX + key);
  } catch (e) {
    return null;
  }
}
function lsSet(key, val) {
  try {
    localStorage.setItem(LS_PREFIX + key, val);
  } catch (e) {}
}
function lsDel(key) {
  try {
    localStorage.removeItem(LS_PREFIX + key);
  } catch (e) {}
}

/* ---- Step checkboxes + progress bar ---- */
var boxes = Array.prototype.slice.call(
  document.querySelectorAll('[data-progress]'),
);
var fill = document.getElementById('progressFill');
var label = document.getElementById('progressLabel');

function updateProgress() {
  var done = boxes.filter(function (b) {
    return b.checked;
  }).length;
  fill.style.width = (done / boxes.length) * 100 + '%';
  label.textContent = done + ' / ' + boxes.length + ' steps';
  boxes.forEach(function (b) {
    var step = b.closest('.step');
    if (step) step.classList.toggle('done', b.checked);
  });
}

boxes.forEach(function (box) {
  var key = box.getAttribute('data-progress');
  box.checked = lsGet(key) === '1';
  box.addEventListener('change', function () {
    lsSet(key, box.checked ? '1' : '0');
    updateProgress();
  });
});
updateProgress();

/* ---- Inline checklist items ---- */
var items = Array.prototype.slice.call(
  document.querySelectorAll('[data-check]'),
);
items.forEach(function (item) {
  var key = 'check:' + item.getAttribute('data-check');
  item.checked = lsGet(key) === '1';
  item.addEventListener('change', function () {
    lsSet(key, item.checked ? '1' : '0');
  });
});

/* ---- Floating notes widget ---- */
var notes = document.getElementById('notesField');
var status = document.getElementById('notesStatus');
var fab = document.getElementById('notesFab');
var fabBubble = document.getElementById('fabBubble');
var panel = document.getElementById('notesPanel');
var saveTimer = null;

notes.value = lsGet('notes') || '';

function updateBubble() {
  fabBubble.classList.toggle('has-notes', notes.value.trim().length > 0);
}
updateBubble();

function togglePanel(open) {
  var willOpen =
    typeof open === 'boolean' ? open : !panel.classList.contains('open');
  panel.classList.toggle('open', willOpen);
  if (willOpen) notes.focus();
}

fab.addEventListener('click', function () {
  togglePanel();
});
document.getElementById('notesClose').addEventListener('click', function () {
  togglePanel(false);
});
document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') togglePanel(false);
});

var notesFinal = document.getElementById('notesFieldFinal');
notesFinal.value = notes.value;

function saveNotes() {
  clearTimeout(saveTimer);
  status.textContent = 'Saving…';
  saveTimer = setTimeout(function () {
    lsSet('notes', notes.value);
    status.textContent = 'Saved on this device ✓';
    updateBubble();
  }, 400);
}

notes.addEventListener('input', function () {
  notesFinal.value = notes.value;
  saveNotes();
});
notesFinal.addEventListener('input', function () {
  notes.value = notesFinal.value;
  saveNotes();
});

document
  .getElementById('copyNotesFinal')
  .addEventListener('click', function () {
    if (!notesFinal.value) return;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(notesFinal.value);
    } else {
      notesFinal.select();
      document.execCommand('copy');
    }
    this.textContent = 'Copied ✓';
    var btn = this;
    setTimeout(function () {
      btn.textContent = 'Copy notes';
    }, 1500);
  });

document.getElementById('copyNotes').addEventListener('click', function () {
  if (!notes.value) {
    status.textContent = 'Nothing to copy yet';
    return;
  }
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(notes.value).then(function () {
      status.textContent = 'Copied to clipboard ✓';
    });
  } else {
    notes.select();
    document.execCommand('copy');
    status.textContent = 'Copied to clipboard ✓';
  }
});

document.getElementById('clearNotes').addEventListener('click', function () {
  if (!notes.value || confirm('Clear all your notes? This can’t be undone.')) {
    notes.value = '';
    lsDel('notes');
    status.textContent = 'Notes cleared';
    updateBubble();
  }
});

/* ---- One-time hand-tap hint pointing at the notes button ---- */
(function () {
  var hint = document.getElementById('fabHint');
  if (!hint || lsGet('hintSeen') === '1') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function positionHint() {
    var r = fab.getBoundingClientRect();
    // place the fingertip near the centre of the button
    hint.style.left = r.left + r.width * 0.5 + 'px';
    hint.style.top = r.top + r.height * 0.42 + 'px';
  }

  function dismiss() {
    hint.classList.remove('run');
    fab.classList.remove('hinting');
    hint.style.display = 'none';
    lsSet('hintSeen', '1');
  }

  setTimeout(function () {
    if (fab.style.display === 'none') return; // not on a screen with the FAB
    positionHint();
    hint.classList.add('run');
    fab.classList.add('hinting');
    // clears itself after the two tap cycles (~2.6s)
    setTimeout(dismiss, 2900);
  }, 1400);

  fab.addEventListener('click', dismiss, { once: true });
  window.addEventListener('resize', positionHint);
})();

/* ---- Mobile wizard ---- */
var mq = window.matchMedia('(max-width: 700px)');
var screens = Array.prototype.slice.call(
  document.querySelectorAll('section[data-screen]'),
);
var wizBack = document.getElementById('wizBack');
var wizNext = document.getElementById('wizNext');
var wizCount = document.getElementById('wizCount');
var footer = document.getElementById('pageFooter');
var current = parseInt(lsGet('screen') || '0', 10);
if (isNaN(current) || current < 0 || current >= screens.length) current = 0;

function nextLabel(i) {
  if (i === 0) return 'Start →';
  if (screens[i].getAttribute('data-screen') === 'step') return 'Done, next →';
  return 'Next →';
}

function showScreen(i) {
  current = i;
  lsSet('screen', String(i));
  screens.forEach(function (s, j) {
    s.classList.toggle('active', j === i);
  });
  wizBack.style.display = i === 0 ? 'none' : '';
  wizNext.style.display = i === screens.length - 1 ? 'none' : '';
  wizNext.textContent = nextLabel(i);
  wizCount.textContent = i + 1 + ' / ' + screens.length;
  footer.classList.toggle('show', i === screens.length - 1);
  // on the finish screen the inline notes field replaces the floating button
  var isFinish = screens[i].getAttribute('data-screen') === 'finish';
  fab.style.display = isFinish ? 'none' : '';
  if (isFinish) {
    togglePanel(false);
    notesFinal.value = notes.value;
    trackGuideFinishView();
  }
  window.scrollTo(0, 0);
}

function applyMode() {
  if (mq.matches) {
    document.body.classList.add('wizard');
    showScreen(current);
  } else {
    document.body.classList.remove('wizard');
    screens.forEach(function (s) {
      s.classList.remove('active');
    });
    footer.classList.remove('show');
    fab.style.display = '';
  }
}

wizNext.addEventListener('click', function () {
  var s = screens[current];
  // "Next" on a step screen also marks that step as done
  var stepKey = s.getAttribute('data-step-key');
  if (stepKey) {
    var box = document.querySelector('[data-progress="' + stepKey + '"]');
    if (box && !box.checked) {
      box.checked = true;
      lsSet(stepKey, '1');
      updateProgress();
      trackStepComplete(stepKey);
    }
  }
  if (current < screens.length - 1) showScreen(current + 1);
});

wizBack.addEventListener('click', function () {
  if (current > 0) showScreen(current - 1);
});

if (mq.addEventListener) mq.addEventListener('change', applyMode);
else mq.addListener(applyMode);
applyMode();
